module.exports = import("https://cdn.jsdelivr.net/gh/contentauth/dash.js@3ecdd3b/samples/c2pa/plugin-dash/c2pa-dash-plugin.js");;